module.exports = __webpack_public_path__ + "image-254d40e0751c.png";